<template>
  <div class="liu" v-wechat-title="'身份认证'">
    <div>
      <!-- 身份证 -->
      <div class="color-f-bg">
        <!-- 提示信息 -->
        <div class="padding-t-10 padding-b-10 page-padding-l-r title-5 say-color ">请拍摄本人的身份证证件</div>
        <!-- 照片信息 -->
        <div class="flex-c title-5 say-color">
          <!-- 人像面 -->
          <div class="flex-1 align-center">
            <div class="idCardStyle" @click="onCameraImgClick('renXiang')">
              <img v-if="renXiang.webUrl" class="img" :src="renXiang.webUrl" />
              <svg-icon v-else class-name="img" icon-class="authenticate-headshot" />
            </div>
            <div class="padding-t-10">人像面</div>
          </div>
          <!-- 国徽面 -->
          <div class="flex-1 align-center">
            <div class="idCardStyle" @click="onCameraImgClick('guoHui')">
              <img v-if="guoHui.webUrl" class="img" :src="guoHui.webUrl" />
              <svg-icon v-else class-name="img" icon-class="authenticate-emblem" />
            </div>
            <div class="padding-t-10">国徽面</div>
          </div>
        </div>
        <div v-if="renXiang.webUrl || guoHui.webUrl" class="padding-t-10 line" />
        <!-- 身份信息 -->
        <!-- 商户姓名 -->
        <div v-if="renXiang.webUrl" class="margin-l-10">
          <div class="page-pading-r">
            <mt-field label="商户姓名" placeholder="请输入商户姓名" v-model.trim="formData.idCardName" />
          </div>
          <div class="line" />
        </div>
        <!-- 法人身份证 -->
        <div v-if="renXiang.webUrl" class="margin-l-10">
          <mt-field label="法人身份证" placeholder="请输入法人身份证" v-model.trim="formData.idCardNum" disabled />
          <div v-if="guoHui.webUrl" class="line" />
        </div>
        <!-- 有效期 -->
        <div v-if="guoHui.webUrl" class="margin-l-10">
          <mt-field v-if="guoHui.webUrl" label="有效期" placeholder="请输入有效期" v-model.trim="formData.dateOf" disabled />
        </div>
      </div>
      <!-- 提示信息 -->
      <div class="flex padding-t-10 padding-b-10 page-padding-l-r title-6 say-color"
        v-show="renXiang.webUrl || guoHui.webUrl">
        <!-- 左侧显示信息 -->
        <div class="flex-1 say-color">如信息有误，请重新拍照</div>
        <!-- 右侧显示信息 -->
        <div>
          <div class="theme-color" @click="resetCameraInfo('renXiang'), resetCameraInfo('guoHui')">重新拍照</div>
        </div>
      </div>
      <div class="flex padding-t-10 padding-b-10 page-padding-l-r title-6 say-color"
        v-show="!renXiang.webUrl && !guoHui.webUrl">
        <div class="flex-1 say-color">
          规范拍照身份证原件，并保证照片的真实性
        </div>
      </div>
      <!-- 手写签名 -->
      <div class="signature">
        <div v-show="flowStep === 2 && isHandSignForReal" class="btn" @click="onSignatrueClick">
          <svg-icon icon-class="write" class-name="svg" />
          <span>点击开始手写签名</span>
        </div>
        <div v-show="flowStep === 3 && isHandSignForReal" class="img">
          <img :src="formData.signatureImg" />
        </div>
      </div>
      <!-- 按钮 -->
      <div class="padding-t-10 padding-b-10 page-padding-l-r">
        <mt-button type="primary" size="large" :disabled="submitDisabled" @click="onSubmitClick">提交</mt-button>
      </div>
    </div>
  </div>
</template>

<script>
/* global PUBLIC_FACE_PHOTO_TIPS */
/* global wx */

import SvgIcon from '@/components/SvgIcon';
import { formatDateLongStr } from '@/utils/utils.js';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { GetIdCardFrontUrlV2, GetIdCardBackUrlV2, } from '@/api/weChat.js';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';

export default {
  name: 'IdCardAuthSignature',
  components: { SvgIcon },
  data() {
    return {
      // 身份证人像面
      renXiang: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
        success: false
      },
      // 身份证国徽面
      guoHui: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
        success: false
      },
      // 表单数据
      formData: {
        idCardName: '',
        idCardNum: '',
        address: '',
        familyName: '',
        birthday: '',
        sex: '',
        office: '',
        dateOfIssue: '',
        dateOfInvalid: '',
        dateOf: '',
        signatureImg: '',
      },
      // 用户手机号
      mobile: '',
      // 活体认证类型
      faceDetectActivity: 0,
      //  活体认证的最大次数
      faceMax: 0,
      // 是否需要手持标识
      userIsNeedHandIdentityCard: false,
      // 是否需要手写签名标识
      isHandSignForReal: false,
      // 身份证识别批次号 2023.4.23
      idCardBatchNo: '',
      // 2024.6.19 签名相关
      flowStep: 1,
    };
  },
  computed: {
    submitDisabled() {
      return this.flowStep === 1;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.mobile = this.$route.query.mobile || 99999999999;
      this.faceDetectActivity = parseInt(this.$route.query.facedetectactivity);
      this.faceMax = this.$route.query.facemax ? parseInt(this.$route.query.facemax) : 50;
      this.userIsNeedHandIdentityCard = this.$route.query.needhandidcard === 'true';
      this.isHandSignForReal = Boolean(parseInt(this.$route.query.ishand));
      this.idCardBatchNo = `${formatDateLongStr(new Date())}${String(Math.floor(Math.random() * 9000000000000 + 1000000000000))}`;
      const imgType = this.$route.query.imgtype;
      if (imgType) {
        this.flowStep = parseInt(this.$route.query.flowstep);
        this.idCardBatchNo = this.$route.query.idcardbatchno;
        this.renXiang.webUrl = decodeURIComponent(this.$route.query.rxweburl).replace('|', '?');
        this.formData.idCardName = this.$route.query.idcardname;
        this.formData.idCardNum = this.$route.query.idcardnum;
        this.formData.address = this.$route.query.address;
        this.formData.familyName = this.$route.query.familyname;
        this.formData.birthday = this.$route.query.birthday;
        this.formData.sex = this.$route.query.sex;
        this.formData.office = this.$route.query.office;
        this.guoHui.webUrl = decodeURIComponent(this.$route.query.ghweburl).replace('|', '?');
        this.formData.dateOfIssue = this.$route.query.dateofissue;
        this.formData.dateOfInvalid = this.$route.query.dateofinvalid;
        this.formData.dateOf = `${this.formData.dateOfIssue} - ${this.formData.dateOfInvalid}`;
        this.formData.signatureImg = decodeURIComponent(this.$route.query.signatureimg).replace('|', '?');
        switch (imgType) {
          case "renXiang":
            this.getIdCardFrontUrlV2();
            break;
          case "guoHui":
            this.getIdCardBackUrlV2();
            break;
        }
      } else {
        if (this.$route.query.signatureimg) {
          this.flowStep = parseInt(this.$route.query.flowstep);
          this.idCardBatchNo = this.$route.query.idcardbatchno;
          this.renXiang.webUrl = decodeURIComponent(this.$route.query.rxweburl).replace('|', '?');
          this.formData.idCardName = this.$route.query.idcardname;
          this.formData.idCardNum = this.$route.query.idcardnum;
          this.formData.address = this.$route.query.address;
          this.formData.familyName = this.$route.query.familyname;
          this.formData.birthday = this.$route.query.birthday;
          this.formData.sex = this.$route.query.sex;
          this.formData.office = this.$route.query.office;
          this.guoHui.webUrl = decodeURIComponent(this.$route.query.ghweburl).replace('|', '?');
          this.formData.dateOfIssue = this.$route.query.dateofissue;
          this.formData.dateOfInvalid = this.$route.query.dateofinvalid;
          this.formData.dateOf = `${this.formData.dateOfIssue} - ${this.formData.dateOfInvalid}`;
          this.formData.signatureImg = decodeURIComponent(this.$route.query.signatureimg).replace('|', '?');
        }
      }
    });
  },
  methods: {
    // 拍照组件点击事件
    onCameraImgClick(type) {
      switch (type) {
        case "renXiang":
        case "guoHui":
          const data = this.createPostMessage(type);
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
      }
    },
    // 开始手写签名按钮点击事件
    onSignatrueClick() {
      const data = {
        page: "signature",
        flowStep: this.flowStep,
        idCardBatchNo: this.idCardBatchNo,
        rxWebUrl: encodeURIComponent(this.renXiang.webUrl.replace('?', '|')),
        idCardName: this.formData.idCardName,
        idCardNum: this.formData.idCardNum,
        address: this.formData.address,
        familyName: this.formData.familyName,
        birthday: this.formData.birthday,
        sex: this.formData.sex,
        office: this.formData.office,
        ghWebUrl: encodeURIComponent(this.guoHui.webUrl.replace('?', '|')),
        dateOfIssue: this.formData.dateOfIssue,
        dateOfInvalid: this.formData.dateOfInvalid,
      };
      wx.miniProgram.postMessage({ data });
      wx.miniProgram.redirectTo({
        url: `/pages/signature/signature`,
      });
    },
    // 提交数据按钮点击事件
    onSubmitClick() {
      if (this.flowStep === 2) {
        CusToast("请完成手写签名");
      } else if (this.flowStep === 3) {
        this.$router.push({
          path: "/auth/liveface", query: {
            mobile: this.mobile,
            facedetectactivity: this.faceDetectActivity,
            facemax: this.faceMax,
            needhandidcard: this.userIsNeedHandIdentityCard,
            idcardbatchno: this.idCardBatchNo,
            idcardname: this.formData.idCardName,
            signatureimg: encodeURIComponent(this.formData.signatureImg.replace('?', '|')),
          }
        });
      } else {
        return;
      }
    },
    // 重新拍照
    resetCameraInfo(name) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
      this[name].success = false;
      this.flowStep = 1;
    },
    // 创建向小程序传递消息的参数对象
    createPostMessage(imgTypeStr) {
      return {
        page: 'media',
        h5Page: 'IdCardAuthSignature',
        imgType: imgTypeStr,
        flowStep: this.flowStep,
        idCardBatchNo: this.idCardBatchNo,
        rxWebUrl: encodeURIComponent(this.renXiang.webUrl.replace('?', '|')),
        idCardName: this.formData.idCardName,
        idCardNum: this.formData.idCardNum,
        address: this.formData.address,
        familyName: this.formData.familyName,
        birthday: this.formData.birthday,
        sex: this.formData.sex,
        office: this.formData.office,
        ghWebUrl: encodeURIComponent(this.guoHui.webUrl.replace('?', '|')),
        dateOfIssue: this.formData.dateOfIssue,
        dateOfInvalid: this.formData.dateOfInvalid,
        signatureImg: encodeURIComponent(this.formData.signatureImg.replace('?', '|')),
      };
    },
    // 调用接口识别身份证正面信息
    getIdCardFrontUrlV2() {
      CusLoadingOpen();
      GetIdCardFrontUrlV2({
        url: this.renXiang.webUrl,
        batchNo: this.idCardBatchNo,
      }).then(res => {
        CusLoadingClose();
        SucceedHandle2(
          res.code,
          res.msg,
          () => {
            this.formData.idCardName = res.data.Name;
            this.formData.idCardNum = res.data.IdCardNum;
            this.formData.address = res.data.Address;
            this.formData.familyName = res.data.FamilyName;
            this.formData.birthday = res.data.Birthday;
            this.formData.sex = res.data.Sex;
            if (this.guoHui.webUrl) {
              if (this.isHandSignForReal) {
                this.flowStep = 2;
              } else {
                this.flowStep = 3;
              }
            }
          },
          (code, msg) => {
            msg && CusAlert(msg, () => {
              this.resetCameraInfo("renXiang");
            });
          }
        );
      })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口识别身份证背面信息
    getIdCardBackUrlV2() {
      CusLoadingOpen();
      GetIdCardBackUrlV2({
        url: this.guoHui.webUrl,
        batchNo: this.idCardBatchNo
      }).then(res => {
        CusLoadingClose();
        SucceedHandle2(
          res.code,
          res.msg,
          () => {
            // 现阶段此接口有BUG，未识别出背面时，code还是为0
            // 特用判断msg的方式补救一下
            if (res.msg !== "") {
              CusAlert(res.msg, () => {
                this.resetCameraInfo("guoHui");
              });
            }
            this.formData.office = res.data.Office;
            this.formData.dateOfIssue = res.data.DateOfIssue;
            this.formData.dateOfInvalid = res.data.DateOfInvalid;
            this.formData.dateOf = `${res.data.DateOfIssue} - ${res.data.DateOfInvalid}`;
            if (this.renXiang.webUrl) {
              if (this.isHandSignForReal) {
                this.flowStep = 2;
              } else {
                this.flowStep = 3;
              }
            }
          },
          (code, msg) => {
            msg && CusAlert(msg, () => {
              this.resetCameraInfo("guoHui");
            });
          }
        );
      })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.line {
  height: 1px;
  border-bottom: 1px solid $border-color;
}

.signature {

  .btn {
    width: 100%;
    height: 2.2rem;
    line-height: 2.2rem;
    background-color: $highlight-color;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .svg {
      width: 0.8rem;
      height: 0.8rem;
      margin-right: 0.4rem;
    }

    span {
      font-size: $title3;
      @include dynamic-color;
    }
  }

  .img {
    width: 100%;
    height: 6rem;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
